import { AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';

export function AnimateProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  return (
    <AnimatePresence mode="wait" initial={isHomePage ? false : true}>
      {children}
    </AnimatePresence>
  );
}
